/**
 * Order Form API Functions
 */
import { fetchPortfolio } from '../../services/portfolioApi';
import { PositionInfo } from '../../types/portfolio';
import { AssetType, OrderSide } from './types';
import { API_BASE_URL } from '../../config';
import { apiFetch } from '../../utils/apiFetch';

export const loadAccountInfo = async (): Promise<number> => {
  const data = await fetchPortfolio();
  return data.account.cash;
};

export const loadPositions = async (): Promise<PositionInfo[]> => {
  const data = await fetchPortfolio();
  return (data.positions || []).filter((pos) => !pos.symbol.endsWith('USD'));
};

export const fetchCurrentPrice = async (
  symbol: string,
  assetType: AssetType
): Promise<number | null> => {
  try {
    const encodedSymbol = encodeURIComponent(symbol.toUpperCase().trim());
    const response = await apiFetch(
      `${API_BASE_URL}/api/market/quote/${encodedSymbol}?asset_type=${assetType}`
    );

    if (response.ok) {
      const data = await response.json();
      return data.price;
    } else {
      return null;
    }
  } catch (err) {
    return null;
  }
};

export const submitMarketOrder = async (
  symbol: string,
  quantity: number,
  side: OrderSide,
  assetType: AssetType
): Promise<void> => {
  const response = await apiFetch(`${API_BASE_URL}/api/trading/orders/market`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      symbol: symbol.toUpperCase().trim(),
      quantity,
      side,
      asset_type: assetType,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(
      errorData.detail || `주문 실패: ${response.status} ${response.statusText}`
    );
  }

  await response.json();
};
